import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { darkMode, toggleTheme } = useTheme();

  const buttonStyles = {
    background: darkMode ? 'rgba(255, 68, 68, 0.2)' : 'rgba(255, 255, 255, 0.2)',
    border: darkMode ? '1px solid rgba(255, 68, 68, 0.4)' : '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: darkMode ? '#ff4444' : 'white',
    backdropFilter: 'blur(10px)',
    padding: 0,
    margin: 0,
    fontSize: '20px'
  };

  const buttonHoverStyles = {
    transform: 'rotate(15deg) scale(1.1)',
    background: darkMode ? 'rgba(255, 68, 68, 0.4)' : 'rgba(255, 255, 255, 0.3)',
    boxShadow: darkMode ? '0 0 15px rgba(255, 68, 68, 0.3)' : 'none'
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      className="theme-toggle-btn"
      onClick={toggleTheme}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Toggle theme"
      style={{
        ...buttonStyles,
        ...(isHovered && buttonHoverStyles)
      }}
    >
      <i className={darkMode ? "fas fa-sun" : "fas fa-moon"}></i>
    </button>
  );
};

export default ThemeToggle;